import { NavLink } from "react-router-dom";
import { useSSEStatus } from "../hooks/useSSEStatus";

const navItems = [
  { to: "/", label: "Fleet Overview", icon: "\u25A3" },
  { to: "/runs", label: "Test Runs", icon: "\u25B7" },
  { to: "/jobs", label: "Job Lookup", icon: "\u2609" },
  { to: "/hosts", label: "Hosts", icon: "\u2630" },
  { to: "/docs", label: "API Docs", icon: "\u2632" },
  { to: "/settings", label: "Settings", icon: "\u2699" },
];

export default function Sidebar() {
  const sseStatus = useSSEStatus("/api/events");
  const statusColor = sseStatus === "connected" ? "#24925c" : sseStatus === "disconnected" ? "#dc4405" : "#ffb549";
  const statusLabel = sseStatus === "connected" ? "Live" : sseStatus === "disconnected" ? "Disconnected" : "Connecting";

  return (
    <nav
      style={{
        width: "var(--sidebar-width)",
        background: "var(--color-primary)",
        color: "var(--color-surface)",
        display: "flex",
        flexDirection: "column",
        flexShrink: 0,
        position: "fixed",
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: 10,
      }}
    >
      <div
        style={{
          padding: "var(--space-xl) var(--space-lg)",
          fontSize: "var(--font-size-xl)",
          fontWeight: 700,
          letterSpacing: "-0.3px",
          borderBottom: "1px solid rgba(255,255,255,0.1)",
          display: "flex",
          alignItems: "center",
          gap: "var(--space-sm)",
        }}
      >
        <img src="/logo.png" alt="Device Hive" style={{ width: 56, height: 56, flexShrink: 0, borderRadius: 10 }} />
        <div>
          Device<span style={{ color: "#ffb549" }}>Hive</span>
        </div>
      </div>

      <ul style={{ listStyle: "none", padding: "var(--space-sm) 0", flex: 1 }}>
        {navItems.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.to === "/"}
              style={({ isActive }) => ({
                display: "flex",
                alignItems: "center",
                gap: "var(--space-sm)",
                padding: "var(--space-md) var(--space-lg)",
                color: isActive ? "var(--color-surface)" : "rgba(255,255,255,0.7)",
                textDecoration: "none",
                fontSize: "var(--font-size-md)",
                minHeight: "var(--touch-target-min)",
                transition: "background 0.15s, color 0.15s",
                background: isActive ? "rgba(255,255,255,0.12)" : "transparent",
                fontWeight: isActive ? 600 : 400,
                borderLeft: isActive
                  ? "3px solid var(--color-info)"
                  : "3px solid transparent",
              })}
            >
              <span style={{ width: 20, height: 20, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: 14, flexShrink: 0 }}>
                {item.icon}
              </span>
              {item.label}
            </NavLink>
          </li>
        ))}
      </ul>

      <div
        style={{
          padding: "var(--space-lg)",
          borderTop: "1px solid rgba(255,255,255,0.1)",
          fontSize: "var(--font-size-sm)",
          color: "rgba(255,255,255,0.4)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 8 }}>
          <span style={{ width: 7, height: 7, borderRadius: "50%", background: statusColor, display: "inline-block" }} />
          <span style={{ fontSize: 11 }}>{statusLabel}</span>
        </div>
        <div style={{ display: "flex", gap: 12, marginBottom: 6, fontSize: 11 }}>
          <a href="/changelog" style={{ color: "rgba(255,255,255,0.5)", textDecoration: "none" }}>Changelog</a>
          <a href="/roadmap" style={{ color: "rgba(255,255,255,0.5)", textDecoration: "none" }}>Roadmap</a>
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span>Device Hive v1.0</span>
          <a
            href="/auth/logout"
            style={{
              color: "rgba(255,255,255,0.5)",
              textDecoration: "none",
              fontSize: 11,
            }}
            onMouseEnter={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.8)"; }}
            onMouseLeave={(e) => { e.currentTarget.style.color = "rgba(255,255,255,0.5)"; }}
          >
            Sign out
          </a>
        </div>
      </div>
    </nav>
  );
}
